// Etykiety wartości ze słowników globalnych (Type / Class / Status) — czysty moduł, bez Reacta.
//
// Nazwy typów, klas i statusów przychodzą z bazy jako tekst („Narty", „Wiosło"). Dla części z
// nich słownik tłumaczeń ma wersje obcojęzyczne pod kluczem `<prefiks>.<nazwa>`, ale typ dodany
// przez firmę (albo przez preset branżowy demo) tłumaczenia nie ma — i wtedy MA się wyświetlić
// jego nazwa, a nie klucz `inventory.type.Wiosło`.
//
// `t()` z translations.js zwraca dla brakującego klucza SAM KLUCZ (nigdy pusty napis), dlatego
// wzorzec `t(key) || nazwa`, używany dotąd przy statusach, nigdy nie spadał do nazwy. Tu porównujemy
// z kluczem. Wcześniej ta sama logika była wklejona osobno w pięciu miejscach.

export function translatedOrRaw(t, key, raw) {
  const translated = typeof t === 'function' ? t(key) : key;
  return translated && translated !== key ? translated : raw;
}

export function typeLabel(t, name) {
  if (name === null || name === undefined || name === '') return '';
  return translatedOrRaw(t, `inventory.type.${name}`, String(name));
}

export function classLabel(t, name) {
  if (name === null || name === undefined || name === '') return '';
  return translatedOrRaw(t, `addEquipment.class.${name}`, String(name));
}

export function equipmentStatusLabel(t, status) {
  if (status === null || status === undefined || status === '') return '';
  return translatedOrRaw(t, `inventory.status.${status}`, String(status));
}
